module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExtIt.bbf2998.eot";